import { useNavigate } from 'react-router-dom';
import ChooseNetwork from 'src/components/common/ChooseNetwork';
import { ConnectWallet } from 'src/components/common/ConnectWallet';
import LootyPoints from 'src/components/common/LootyPoints';

function AppNavbar() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between pr-[61px] pl-[67px] pt-[25px] mb-[55px] w-full">
      <div className="relative w-[121px] h-[34px] cursor-pointer" onClick={() => navigate('/')}>
        <img
          src="/assets/icons/app-logo.png"
          alt="Go to home"
          className="absolute inset-0 w-full h-full opacity-0 logo-hover"
        />
        <img
          src="/assets/icons/app-logo-hover.png"
          alt="Go to home"
          className="absolute inset-0 w-full h-full logo-default"
        />
      </div>

      <div className="flex items-center gap-8">
        <LootyPoints />
        <ChooseNetwork />
        <ConnectWallet />
      </div>
    </div>
  );
}

export default AppNavbar;
